var _rect, _rect2, _rect3, _rect4, _rect5, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCashClosed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 24,
    viewBox: "0 0 34 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 24,
    rx: 4,
    fill: "#3C3E52"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    width: 28,
    height: 2,
    fill: "#11121D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 22,
    width: 28,
    height: 2,
    fill: "#11121D"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 21,
    width: 18,
    height: 2,
    transform: "rotate(-90 0 21)",
    fill: "#11121D"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 21,
    width: 18,
    height: 2,
    transform: "rotate(-90 32 21)",
    fill: "#11121D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 12,
    r: 6,
    fill: "#11121D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    fill: "#11121D"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 12,
    r: 2,
    fill: "#11121D"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 12,
    r: 2,
    fill: "#11121D"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 20.5,
    r: 3.5,
    fill: "#11121D"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 3.5,
    r: 3.5,
    fill: "#11121D"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 20.5,
    r: 3.5,
    fill: "#11121D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashClosed);
export default __webpack_public_path__ + "static/media/cashClosed.673e0dee.svg";
export { ForwardRef as ReactComponent };